import { styled } from '@linaria/react';

import { StyledGroup } from '../styles';

export const FooterStyledGroup = styled(StyledGroup)`
	display: flex;
	padding-right: 0.8rem;
	padding-left: 0.8rem;
	gap: var(--gap-x4);
`;

export const TocStyledGroup = styled(StyledGroup)`
	display: flex;
	flex-direction: column;
	padding: 2rem 0.8rem;
	gap: var(--gap-x4);

	& > * {
		display: flex;
		justify-content: flex-start;
	}
`;
